

import { initIndividualVariantState, updateCardByProductIdState, unselectAllProducts } from '@yggdrasil/Checkout/V2/CheckoutProductSelect/V2/checkoutProductSelect'
import { CF2Component, registerComponent } from 'javascript/lander/runtime'

export default class CheckoutV2 extends CF2Component {

constructor(el, runtimeSel) {
super(el, runtimeSel)
}



  mount() {
    if (this.variantDisplay === 'individual') {
      initIndividualVariantState()
    }
    const paymentGateway = typeof StripeCheckout === "function" ? "stripe" : "rebilly"
    const concreteCheckout = paymentGateway === "stripe"
      ? this.getComponent(StripeCheckout)
      : this.getComponent(RebillyCheckout)

    if (concreteCheckout?._lazyInitPending) {
      this.element.querySelector('.elCheckoutWrapper')?.classList.add('elCheckoutLazyPlaceholder')

      let triggered = false
      const triggerInit = async () => {
        if (triggered) return
        triggered = true
        observer?.disconnect()

        this.element.querySelector('.elCheckoutWrapper')?.classList.remove('elCheckoutLazyPlaceholder')
        await concreteCheckout._performLazyInit()
        this.initializeStoreDependentElements(Checkout.store, Checkout.computed)
      }

      const observer = new IntersectionObserver((entries) => {
        if (entries.some(e => e.isIntersecting)) triggerInit()
      }, { rootMargin: '200px' })
      observer.observe(this.element)

      // OTO buttons must force-init
      $(document).on('click', '[href="#submit-oto"]', async (evt) => {
        evt.preventDefault()
        evt.stopPropagation()
        await triggerInit()
      })

      return
    }

    const checkoutLoading = this.getComponentGroup(CheckoutLoadingV1)

    // Global, not per host: a second button's attempt must not leave the first button's message
    // on screen pointing at a product the buyer is no longer trying to buy.
    const clearOtoErrors = () => {
      document.querySelectorAll('.elOtoButtonError').forEach((node) => node.remove())
    }

    const renderOtoError = (host, message) => {
      clearOtoErrors()
      const node = document.createElement('div')
      node.className = 'elOtoButtonError'
      node.setAttribute('role', 'alert')
      node.setAttribute('aria-live', 'polite')
      node.textContent = message
      node.style.cssText = 'margin-top:8px;color:#df1b41;font-size:15px;line-height:1.4;text-align:center;'
      host.insertAdjacentElement('afterend', node)
    }

    // Use event delegation to handle multiple OTO buttons independently
    $(document).on('click', '[href="#submit-oto"]', async function(evt) {
      evt.preventDefault()
      evt.stopPropagation()
      
      const clickedButton = evt.currentTarget
      const element = clickedButton.closest<CF2Element>(`[data-page-element]`)
      const otoProductVariantPrice = element?.dataset?.selectedProduct
      const redirectOverride = element?.dataset?.otoRedirectOverride
      
      if (!otoProductVariantPrice) {
        console.error('No product selected for this OTO button')
        return
      }
      
      clearOtoErrors()

      const [product_id, variant_id, price_id] = otoProductVariantPrice.split('-')
      
      unselectAllProducts()
      updateCardByProductIdState(product_id, { 
        variantId: variant_id, 
        priceId: price_id, 
        quantity: 1
      })

      const closestPaintColor = $(evt.target).closest('[data-paint-colors]').attr('data-paint-colors') ?? 'lightest'
      $('.id-checkout-modal-node-id').find('[data-page-element="Checkout/V2"]').attr('data-paint-colors', closestPaintColor)
      $('.id-checkout-modal-node-id').css('display', 'flex');
      checkoutLoading.show()
      $('.elCheckoutCTAHeader').hide();
      $('.elCheckoutBodyContainer').hide();

      function cartHasOnlySelectedVariant(cart, v2) {
        if(cart.items.length != 1 || cart.items[0].quantity != 1) {
            return false
        }
        const v1 = cart.items[0]

        return (v1.product_id == v2.product_id &&
          v1.variant_id == v2.variant_id &&
          v1.price_id == v2.price_id)
      }

      // Undo the hiding the click did, so the checkout is usable again wherever it lives -- inside
      // the auto-placed modal, or on the page itself when it has its own element.
      const restoreCheckoutBody = () => {
        $('.elCheckoutCTAHeader').show()
        $('.elCheckoutBodyContainer').show()
        checkoutLoading.hide()
      }

      // Hand the buyer the checkout they never asked to see only when there is something in it for
      // them to do -- correct a field, use another card.
      const showModal = restoreCheckoutBody

      // Nothing for them to act on: close the modal, say why under the button they pressed, and
      // leave the page as it was so the offer stays skippable.
      const showInlineError = (message) => {
        $('.id-checkout-modal-node-id').css('display', 'none')
        restoreCheckoutBody()
        renderOtoError(element, message)
      }

      const handleFailure = (result) => {
        if (result && result.actionable === false && result.message) {
          showInlineError(result.message)
        } else {
          showModal()
        }
      }

      // A rejected promise out of submitOTO -- a response shape the transport did not expect, a
      // thrown handler -- would otherwise escape this async listener and leave the modal open on
      // its spinner, which is the symptom this handler exists to remove. Treat it as an actionable
      // failure: the buyer gets the checkout back and can retry.
      const submitOtoSafely = async () => {
        try {
          return await concreteCheckout.submitOTO(redirectOverride)
        } catch (error) {
          console.error('[OTO] submit failed unexpectedly', error)
          return { ok: false, actionable: true }
        }
      }

      if (paymentGateway === "stripe") {
        concreteCheckout.checkout.preventOrderPreview = true
        await concreteCheckout.checkout.sendOrderPreview({skipThrottle: true, forceOrderPreview: true})
        const summary = globalThis.Checkout.store.summary.get()
        if (summary.state == globalThis.Checkout.SummaryStates.OK) {
          const result = await submitOtoSafely()
          if (!result.ok) {
            concreteCheckout.checkout.preventOrderPreview = false
            handleFailure(result)
          }
        } else {
          // Not settled (WAITING/CALCULATING) or the preview itself failed. Either way the checkout
          // is the right place to land: it already renders the preview error, and some of those
          // -- a postal code the tax lookup rejected -- the buyer can only fix in the form.
          concreteCheckout.checkout.preventOrderPreview = false
          showModal()
        }
      } else {
        let settled = false
        let unsubscribe = null
        const teardown = () => {
          if (!unsubscribe) return
          unsubscribe()
          unsubscribe = null
        }

        const onSummary = async (summary) => {
          if (settled) return

          if (summary.state == globalThis.Checkout.SummaryStates.OK) {
            // The cart was swapped just above, but the derived cart can still be a tick behind on
            // the synchronous first callback. Stay subscribed until it catches up instead of
            // spending the attempt on the previous selection.
            if (!cartHasOnlySelectedVariant(concreteCheckout.getCart(), {product_id, variant_id, price_id})) {
              return
            }
            settled = true
            teardown()
            const result = await submitOtoSafely()
            if (!result.ok) {
              handleFailure(result)
            }
          } else if (summary.state == globalThis.Checkout.SummaryStates.WAITING) {
            settled = true
            teardown()
            showModal()
          } else if (summary.state == globalThis.Checkout.SummaryStates.ERROR) {
            // Same freshness guard as the OK branch. subscribe() replays the pre-click summary,
            // and the cart swap above only queues a debounced preview -- so an ERROR seen here can
            // belong to the previous selection and be about to clear itself. Settling on it would
            // turn a transient blip into a lost upsell.
            if (!cartHasOnlySelectedVariant(concreteCheckout.getCart(), {product_id, variant_id, price_id})) {
              return
            }
            settled = true
            teardown()
            // The checkout already renders the preview error in its general-errors block, and it
            // matches the Stripe branch: a failed preview opens the checkout on both gateways.
            showModal()
          }
        }

        unsubscribe = globalThis.Checkout.store.summary.subscribe(onSummary)
        // subscribe() runs the callback synchronously, so an attempt that settled on that first
        // pass did so before the assignment above -- drop the subscription now that we hold it.
        if (settled) {
          teardown()
        }
      }
    })


  }

  initializeStoreDependentElements(store, computed) {
    const checkoutElements = this.getAllComponents()
    const linkedElements = [...document.querySelectorAll(`[data-linked-checkout-id="${this.id}"]`)].map((el) => el.cf2_instance)
    const allElements = checkoutElements.concat(linkedElements)
    allElements.forEach((el) => {
      el?.initializeWithStore && el.initializeWithStore(store, computed)
    })
  }

  afterMount() {
    if (!Checkout?.store) return
    this.initializeStoreDependentElements(Checkout.store, Checkout.computed)

    const productVariantWithNoBump = globalThis.globalResourceData.productVariantWithNoBump
    if (productVariantWithNoBump?.product_id) {
      const variantId = productVariantWithNoBump.id
      const productId = productVariantWithNoBump.product_id
      updateCardByProductIdState(productId, { variantId })
    }
  }



}

registerComponent('Checkout/V2', CheckoutV2)
window["CheckoutV2"] = CheckoutV2

